module.exports = __webpack_public_path__ + "static/img/navbar_2.791c3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_2.png
// module id = 6caw
// module chunks = 25